<div
    (window:resize)="onResize($event)"
    (window:popstate)="onPopState($event)"
    (window:touchmove)="onTouchMove($event)">
</div>
<ng-container *ngIf="!showMaintenance">
<router-outlet></router-outlet>
</ng-container>

<ng-container *ngIf="showMaintenance">
<app-maintenance></app-maintenance>
</ng-container>